import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Menu, Dropdown, Tooltip, Space, Popover } from 'antd'
import QuestionCircleOutlined from '@ant-design/icons/QuestionCircleOutlined'
import classNames from 'classnames'
import SceneFilteringBoxWrapper from '@/modules/globals/components/SceneFilteringBoxWrapper'
import isNil from 'lodash/isNil'
import isEqual from 'lodash/isEqual'

import DownOutlined from '@ant-design/icons/DownOutlined'
import CustomIcon from '@/components/CustomIcon'

import styles from './index.less'

export const Wenhao = React.memo(({ questionTips, className }) => {
    if (!questionTips) {
        return null
    }
    return (
        <Tooltip
            overlay={null}
            placement="topLeft"
            overlayStyle={{ fontSize: '12px', maxWidth: '340px' }}
            title={questionTips}
            color="rgba(0,0,0,0.7)"
        >
            <QuestionCircleOutlined className={className} />
        </Tooltip>
    )
})

const sc_pic =
    'https://assets.sursung.com/activity/2024_imgs/dis/1/20221012/front/359EC0D43ADC4EBCB159FCC9BD05D1F81665543645631.jpg'
const gyl_pic =
    'https://assets.sursung.com/activity/2024_imgs/dis/1/20221012/front/95470F7519254466A6A572AD0BE1474B1665543665769.jpg'

export const double11Content = (
    <div className={styles.doubleContent}>
        <span>大促期间/数据量过大将不展示统计数据，您可点击筛选后，查看右下角&quot;共x条&quot;售后单</span>
        <img src={window.MASTER_IS_SUPPLIER ? sc_pic : gyl_pic} alt="" />
    </div>
)

export default ({
    name,
    iconType,
    rightExtra,
    noNum,
    onSet,
    noValue = {},
    logText = '',
    menuOptions = [],
    menuContent, // 支持menu自定义
    hideLabel = false,
    svgPic,
    tip,
    noCancel, // 点自己不可取消选中
    tootips,
    hideSelect,
    rightSlot,
    numberStyle,
    svgStyle = {},
    renderContent,
    dropList,
    questionTips,
    showNew,
    iconTypeClass,
    leftBoxStyle = {},
    numShowWenhao,
    needSplitIcon,
    dropDownOptionClassName
}) => {
    const [value, setvalue] = useState()
    const [curObj, setCurObj] = useState()

    useEffect(() => {
        if (!isEqual(value, noValue)) {
            setvalue(noValue)
        }
    }, [noValue])

    useEffect(() => {
        setCurObj({ svgPic, name, noNum, tip, rightExtra })
    }, [svgPic, name, noNum, tip, rightExtra])

    const onChange = (obj, eventType) => {
        setvalue(obj)
        onSet && onSet(obj, eventType)
    }

    const handleClick = useCallback(
        ({ key }) => {
            const item = menuOptions.find(i => String(i.value) === key)

            const obj = {
                ...item,
                checked: true,
                name: curObj?.name
            }
            onChange(obj, 'menuOption')
        },
        [curObj?.name, menuOptions]
    )
    const handleClickMenuLeft = e => {
        const item = dropList?.find(i => String(i.name) === e?.key)
        setCurObj({
            svgPic: item?.svgPic,
            name: item?.name,
            noNum: item?.noNum,
            rightExtra: item?.rightExtra
        })
        const obj = {
            ...value,
            checked: true,
            name: item?.name
        }

        onChange(obj, 'menuLeftOption')
    }

    const menu = menuContent || (
        <Menu onClick={handleClick}>
            {menuOptions.map(item => {
                return (
                    <Menu.Item key={item.value}>
                        <div>{item.label}</div>
                    </Menu.Item>
                )
            })}
        </Menu>
    )
    const menuLeft = (
        <Menu onClick={handleClickMenuLeft}>
            {dropList?.map(item => {
                return (
                    <Menu.Item key={item.name}>
                        <Space size={4}>
                            {typeof item.svgPic === 'string' ? (
                                <img src={item.svgPic} alt="" className={styles.svg} style={svgStyle} />
                            ) : (
                                item.svgPic
                            )}
                            <span className={classNames(styles.num)}>{item.noNum ?? ''}</span>
                            {item?.rightExtra}
                        </Space>
                    </Menu.Item>
                )
            })}
        </Menu>
    )

    const label = useMemo(() => {
        const current = (menuOptions || []).find(v => v.value === value?.value)
        return current?.label || value?.label
    }, [value, menuOptions])

    const logProps = {}

    if (logText) {
        logProps['data-log-text'] = logText
    }

    const onClickNode = () => {
        if (noCancel && value.checked) {
            return
        }
        const obj = {
            ...value,
            checked: !value.checked,
            name: curObj?.name
        }
        onChange(obj, 'menuLeft')
    }

    const renderDefaultShowContent = (
        <div
            {...logProps}
            className={classNames(styles.leftBox, {
                [styles.selected]: !!value?.checked,
                [styles.question]: !!questionTips
            })}
            style={leftBoxStyle}
            onClick={onClickNode}
        >
            <span>
                {typeof curObj?.svgPic === 'string' ? (
                    <img src={curObj?.svgPic} alt="" className={styles.svg} style={svgStyle} />
                ) : (
                    curObj?.svgPic
                )}
            </span>
        </div>
    )

    const renderTip = () => {
        if (curObj?.tip) {
            return (
                <Tooltip
                    overlay={null}
                    color="rgba(0,0,0,0.7)"
                    arrowPointAtCenter
                    placement="topLeft"
                    title={curObj?.tip}
                >
                    <QuestionCircleOutlined className={styles.icon_action} key="Icon" />
                </Tooltip>
            )
        }
        if (iconType) {
            if (typeof iconType === 'string') {
                return (
                    <CustomIcon
                        key="Icon"
                        className={classNames(styles.arrowDownIcon, iconTypeClass)}
                        type={iconType}
                    />
                )
            }
            return <div className={styles.arrowDownIcon}>{iconType}</div>
        }

        if (needSplitIcon) {
            return (
                <div style={{ width: 14, position: 'relative' }}>
                    <Wenhao className={styles.wenhao} questionTips={questionTips} />
                </div>
            )
        }
    }
    const renderCount = () => {
        if (numShowWenhao && curObj?.noNum === -1) {
            return (
                <Popover content={double11Content} placement="bottom" zIndex={1050}>
                    <CustomIcon type="icon-tishi1" className={styles.icon_wenhao} />
                </Popover>
            )
        }

        if (!isNil(curObj?.noNum)) {
            return (
                <span style={numberStyle} className={styles.num}>
                    {curObj?.noNum}
                </span>
            )
        }
        return null
    }

    const node = dropList?.length ? (
        <Dropdown
            overlayClassName={styles.dropdownOverlay1}
            placement="bottomLeft"
            getPopupContainer={triggerNode => triggerNode.parentElement}
            overlay={menuLeft}
        >
            <Space size={4}>
                {renderDefaultShowContent}
                {renderCount()}
                {curObj?.rightExtra}
                <DownOutlined style={{ fontSize: '12px' }} className={styles.arrowDownIcon} />
            </Space>
        </Dropdown>
    ) : (
        renderDefaultShowContent
    )

    const renderLeft = () => {
        if (typeof renderContent === 'function') {
            return <>{renderContent(node)}</>
        }

        return node
    }

    return (
        <SceneFilteringBoxWrapper
            isSelected={!!value?.checked}
            onClickFirstSolt={onClickNode}
            solts={[
                {
                    content: <div className={styles.leftBox}>{renderLeft()}</div>,
                    count: dropList?.length ? null : renderCount(), // 左侧有下拉的，数字和下拉箭头在drwoDown里渲染，不然悬浮不触发下拉
                    renderTip,
                    itemTootips: tootips
                    // className: styles.firstBoxStyle
                },
                rightSlot
                    ? rightSlot
                    : {
                          content: (
                              <div style={{ position: 'relative' }}>
                                  <div className={styles.midLine} />
                                  <Dropdown
                                      overlayClassName={styles.dropdownOverlay2}
                                      placement="bottomLeft"
                                      getPopupContainer={triggerNode => triggerNode.parentElement}
                                      overlay={menu}
                                  >
                                      <span className={classNames(styles.options, dropDownOptionClassName)}>
                                          {hideLabel ? null : (
                                              <span
                                                  className="gylColorGrayN7"
                                                  style={{ color: value?.checked && '#000' }}
                                                  data-log
                                              >
                                                  {label}
                                              </span>
                                          )}

                                          <DownOutlined
                                              className={classNames({
                                                  [styles.icon]: true,
                                                  [styles.hideLabel]: hideLabel
                                              })}
                                          />
                                      </span>
                                  </Dropdown>
                              </div>
                          ),
                          hidden: hideSelect,
                          style: {
                              display: 'flex',
                              alignItem: 'center'
                          }
                      }
            ]?.filter(item => !item?.hidden)}
            showNewIcon={showNew}
        />
    )
}
